import posthog from 'posthog-js'

const apiKey = import.meta.env.VITE_POSTHOG_KEY

/**
 * Hostnames, na ktoré posthog-js pridá hlavičky `X-POSTHOG-DISTINCT-ID` / `X-POSTHOG-SESSION-ID`.
 * API (`PostHogExceptionFilter`) nimi spojí BE 500 s FE userom a session replayom.
 * `tracing_headers` berie zoznam hostnames (bez protokolu/cesty).
 */
function getTracingHeaderHosts(): string[] {
  const apiHosts = [
    import.meta.env.VITE_REACT_API_HOST,
    import.meta.env.VITE_REACT_API2_HOST,
  ]

  return apiHosts
    .filter(
      (apiHost): apiHost is string =>
        typeof apiHost === 'string' && apiHost.length > 0
    )
    .map((apiHost) => new URL(apiHost).hostname)
}

if (apiKey) {
  posthog.init(apiKey, {
    api_host: 'https://eu.i.posthog.com',
    cross_subdomain_cookie: true,
    persistence: 'cookie',
    defaults: '2025-05-24',
    // Error tracking (náhrada Sentry): window.onerror + unhandledrejection.
    capture_exceptions: true,
    tracing_headers: getTracingHeaderHosts(),
  })

  // Dev debug: `posthog.get_session_id()`, `posthog.sessionRecordingStarted()` z konzoly.
  if (import.meta.env.DEV) {
    ;(window as Window & { posthog?: typeof posthog }).posthog = posthog
  }
}
